import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DesyAngularModule } from 'desy-angular';

@Component({
  selector: 'app-buttons',
  imports: [DesyAngularModule, CommonModule, RouterModule],
  templateUrl: './buttons.component.html',
  styleUrl: './buttons.component.scss',
  standalone: true,
})
export class ButtonsComponent {
  @Input() positions: string = 'left';
  @Input() label: string = '';
  @Input() icon: string = '';
  @Input() routerLink: string = '';
  @Input() classes: string = '';
  @Input() isWhite: boolean = true;
  @Input() clickEvent?: () => void;
  @Input() disabled: boolean = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';

  classPositions = this.positions === 'right' ? 'flex flex-reverse gap-4' : 'flex gap-4';

  onClick() {
    if (this.clickEvent) {
      this.clickEvent();
    }
  }
}
